import { useQuery } from '@tanstack/react-query';
import { CLNotificationsApi } from 'api/CL/CLNotificationApi';
import { GetNotificationListReqData } from 'models/CL/CLApiTypes';

export const useGetNotificationListQueries = (reqData: GetNotificationListReqData, options?: { enabled?: boolean }) => {
    const token = process.env.REACT_APP_CL_ADMIN_KEY!;

    return useQuery({
        queryKey: ['getNotificationListQueries', reqData.userId, reqData.offset, reqData.limit],
        queryFn: async () => {
            try {
                const response = await CLNotificationsApi.getNotificationList(reqData, token);
                return (response as any).data;
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알림 데이터를 불러오지 못했습니다';
                throw new Error(errorMessage);
            }
        },
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: options?.enabled !== undefined ? options.enabled : (!!reqData.userId && !!token)
    });
}; 